import i18next from 'i18next';
import {ExternalAccountType} from '../../backend/enums/external-account-type';
import {translations} from '../../i18n/translations';

/**
 * Returns the display label for an external account type.
 */
export const getExternalAccountTypeLabel = (type: ExternalAccountType | string): string => {
  switch (type) {
    case ExternalAccountType.Call:
      return i18next.t(translations.external_accounts.types.call);
    case ExternalAccountType.PartnerP3N1:
      return i18next.t(translations.external_accounts.types.partner_p3_n1);
    case ExternalAccountType.PartnerP3N2:
      return i18next.t(translations.external_accounts.types.partner_p3_n2);
    case ExternalAccountType.PartnerP3N3:
      return i18next.t(translations.external_accounts.types.partner_p3_n3);
    case ExternalAccountType.PartnerP3N4:
      return i18next.t(translations.external_accounts.types.partner_p3_n4);
    default:
      return type;
  }
};
